import { AvatarStack, Box } from '@factorialco/deprecated-design-system'
import { ParticipantEmployeeFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  employees: ParticipantEmployeeFragment[]
}

const MAX_STACKED_USERS = 3

export const Participants = ({ employees }: Props) => (
  <Box alignItems="flexStart">
    <AvatarStack
      overlap="s8"
      size="s40"
      avatars={employees.slice(0, MAX_STACKED_USERS).map((employee) => ({
        label: employee?.fullName ?? '',
        url: buildUrl(employee?.avatar?.url),
      }))}
      leftover={employees.length - MAX_STACKED_USERS}
      textColor="viridian1000"
      textSize="200"
      backgroundColor="viridian200"
    ></AvatarStack>
  </Box>
)
